module.exports = __webpack_public_path__ + "static/media/test.25318602.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test.jpg
// module id = 450
// module chunks = 0